import { StateModel } from 'src/shared/models';
import {
  GET_DYNAMIC_FAQS,
  GET_DYNAMIC_FAQS_ERROR,
  GET_DYNAMIC_FAQS_SUCCESS,
} from '../actions/dynamic-faq.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const dynamicFaqReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_DYNAMIC_FAQS:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_DYNAMIC_FAQS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload.content,
      };
    case GET_DYNAMIC_FAQS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };

    default:
      return state;
  }
};

export default dynamicFaqReducer;
